import { BuilderJSON } from 'store';
import { RenderIf } from 'utilities/helpers';
import Carousel, { CarouselItem } from 'pages/storebuilder/components/carousel';
import { ButtonThemePrimary } from 'pages/storebuilder/components/forms/buttons/themeprimary';
import styles from './index.module.css';

export const BuilderThemeHomeFeatured = ({ title }) => {
  const { pages, screenView } = BuilderJSON((state) => state);
  const { primary } = pages?.global?.style?.button;
  const { content, style } = pages?.landing?.featuredSections?.filter(
    (sec) => sec?.title === title
  )[0];

  return (
    <>
      <article
        id={title?.split(` `)?.join(`_`)}
        className={
          screenView === `WEB_VIEW`
            ? styles.article
            : `${styles.article} ${styles.mobileView}`
        }
        style={{
          backgroundColor: style?.backgroundColor,
          backgroundImage: `url(${style?.backgroundImage})`,
          color: style?.foregroundColor,
          marginTop: `${style?.marginTop}px`,
          marginBottom: `${style?.marginBottom}px`,
          paddingTop: `${style?.paddingTop}px`,
          paddingBottom: `${style?.paddingBottom}px`
        }}
      >
        <div
          className={content?.contentInContainer ? `contBx` : ``}
          style={{
            paddingLeft:
              screenView === `WEB_VIEW` && content?.contentInContainer
                ? `var(--builder-theme-horizontal-padding)`
                : screenView !== `WEB_VIEW` && content?.contentInContainer
                ? `16px`
                : ``,
            paddingRight:
              screenView === `WEB_VIEW` && content?.contentInContainer
                ? `var(--builder-theme-horizontal-padding)`
                : screenView !== `WEB_VIEW` && content?.contentInContainer
                ? `16px`
                : ``
          }}
        >
          <div
            className={content?.layout === 1 ? styles.layout1 : styles.layout2}
            style={{ color: style?.foregroundColor }}
          >
            <RenderIf isTrue={content?.layout === 1}>
              <RenderIf isTrue={content?.subTitle}>
                <div className={styles.subTitleOuter}>
                  <div className={styles.subTitleInner}>
                    <h2
                      className={styles.subTitle}
                      style={{ whiteSpace: `pre-line` }}
                    >
                      {content?.subTitle}
                    </h2>
                    <div
                      className={styles.hr}
                      style={{
                        background: style?.foregroundColor
                          ? style?.foregroundColor
                          : `rgba(0, 0, 0, 1)`,
                        opacity: 0.24
                      }}
                    ></div>
                  </div>
                </div>
              </RenderIf>
              <div className={styles.layout1Inner}>
                <div>
                  <Carousel
                    showIndicators={false}
                    pageLHorizontalCenter={true}
                    pageLRight={`0`}
                    pageLBottom={`0`}
                    pageLLeft={`0`}
                    pageLColor={style?.foregroundColor}
                  >
                    {content?.slides?.map((item, index) => (
                      <CarouselItem key={index}>
                        <div className={styles.slideOuter}>
                          <RenderIf isTrue={item?.category}>
                            <div className={styles.categoryOuter}>
                              <div className={styles.category}>
                                <div>{item?.category}</div>
                                <div
                                  style={{
                                    borderBottom: `${primary?.backgroundColor} 3px dotted`
                                  }}
                                ></div>
                              </div>
                            </div>
                          </RenderIf>
                          <div className={styles.slide}>
                            <div>
                              <RenderIf isTrue={item?.title}>
                                <h1 style={{ whiteSpace: `pre-line` }}>
                                  {item?.title}
                                </h1>
                              </RenderIf>
                              <RenderIf isTrue={item?.description}>
                                <div style={{ whiteSpace: `pre-line` }}>
                                  {item?.description}
                                </div>
                              </RenderIf>
                              <div>
                                <ButtonThemePrimary handleClick={() => {}}>
                                  ORDER NOW
                                </ButtonThemePrimary>
                              </div>
                            </div>
                            <div>
                              <RenderIf isTrue={item?.media}>
                                <picture>
                                  <source srcSet={item?.media} />
                                  <img src={item?.media} alt={item?.title} />
                                </picture>
                              </RenderIf>
                            </div>
                          </div>
                        </div>
                      </CarouselItem>
                    ))}
                  </Carousel>
                </div>
                <div>
                  <RenderIf isTrue={content?.title}>
                    <h1 style={{ whiteSpace: `pre-line` }}>{content?.title}</h1>
                  </RenderIf>
                  <RenderIf isTrue={content?.description}>
                    <p style={{ whiteSpace: `pre-line` }}>
                      {content?.description}
                    </p>
                  </RenderIf>
                </div>
              </div>
            </RenderIf>
            <RenderIf isTrue={content?.layout === 2}>
              <div>
                <RenderIf isTrue={content?.title}>
                  <h1 style={{ whiteSpace: `pre-line` }}>{content?.title}</h1>
                </RenderIf>
              </div>
              <div>
                <RenderIf isTrue={content?.subTitle}>
                  <div className={styles.subTitleOuter}>
                    <div className={styles.subTitleInner}>
                      <h2
                        className={styles.subTitle}
                        style={{ whiteSpace: `pre-line` }}
                      >
                        {content?.subTitle}
                      </h2>
                    </div>
                  </div>
                </RenderIf>
                <RenderIf isTrue={content?.description}>
                  <div style={{ marginTop: 20 }}></div>
                  <p style={{ whiteSpace: `pre-line` }}>
                    {content?.description}
                  </p>
                </RenderIf>
              </div>
              <div>
                <Carousel
                  showIndicators={false}
                  pageLHorizontalCenter={true}
                  pageLRight={`0`}
                  pageLBottom={`0`}
                  pageLLeft={`0`}
                  pageLColor={style?.foregroundColor}
                >
                  {content?.slides?.map((item, index) => (
                    <CarouselItem key={index}>
                      <div className={styles.slideOuter}>
                        <RenderIf isTrue={item?.category}>
                          <div className={styles.categoryOuter}>
                            <div className={styles.category}>
                              <div style={{ padding: `0 20px` }}>
                                {item?.category}
                              </div>
                              <div
                                style={{
                                  borderBottom: `${primary?.backgroundColor} 2px solid`
                                }}
                              ></div>
                            </div>
                          </div>
                        </RenderIf>
                        <div className={styles.slide}>
                          <div
                            className={styles.slideOverlay}
                            style={{
                              backgroundColor: primary?.backgroundColor,
                              opacity: 0.08
                            }}
                          ></div>
                          <div>
                            <RenderIf isTrue={item?.media}>
                              <picture>
                                <source srcSet={item?.media} />
                                <img src={item?.media} alt={item?.title} />
                              </picture>
                            </RenderIf>
                          </div>
                          <div>
                            <RenderIf isTrue={item?.title}>
                              <h1 style={{ whiteSpace: `pre-line` }}>
                                {item?.title}
                              </h1>
                            </RenderIf>
                            <RenderIf isTrue={item?.description}>
                              <div style={{ whiteSpace: `pre-line` }}>
                                {item?.description}
                              </div>
                            </RenderIf>
                            <div>
                              <ButtonThemePrimary handleClick={() => {}}>
                                ORDER NOW
                              </ButtonThemePrimary>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CarouselItem>
                  ))}
                </Carousel>
              </div>
            </RenderIf>
          </div>
        </div>
      </article>
    </>
  );
};
